import { useDisableTeam } from "@/components/page/disableTeam";
import { useOutletContext } from "react-router-dom";
import type { MeetingRunContext } from "./MeetingRunContext";
import { MeetingRunRollCallSection } from "./MeetingRunRollCallSection";
import { MeetingRunMotionsSection } from "./MeetingRunMotionsSection";
import { MeetingRunNoApprovalItemSection } from "./MeetingRunNoApprovalItemSection";
//import { MeetingRunItemSection } from "./MeetingRunItemSection";
import { MeetingRunItem } from "./MeetingRunItem";

export const MeetingRunSection = () => {
  useDisableTeam();
  const { meetingItem, agendaItem } = useOutletContext() as MeetingRunContext;

  return (
    <div className="cc-wrapper flex flex-grow flex-col p-4 pt-0 min-h-0">
      {meetingItem === "roll-call" ? (
        <MeetingRunRollCallSection key={meetingItem} />
      ) : meetingItem === "motions" ? (
        <MeetingRunMotionsSection key={meetingItem} />
      ) : agendaItem?.approver?.approverType !== "team" ? (
        <MeetingRunNoApprovalItemSection key={meetingItem} />
      ) : (
        <MeetingRunItem key={meetingItem} />
      )}
    </div>
  );
};
